import { yupResolver } from "@hookform/resolvers/yup";
import { CourseStickyBarContent } from "api/shop";
import { PaziaFormButton, PaziaInput } from "components/atoms";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

interface CourseStickyBarFormProps {
  onSubmit: (data: CourseStickyBarFormValues) => void;
  onCancel: () => void;
  defaultValues?: CourseStickyBarContent;
  isLoading?: boolean;
}

export const CourseStickyBarForm = ({ onSubmit, onCancel, defaultValues, isLoading }: CourseStickyBarFormProps) => {
  const methods = useForm<FormValues>({
    resolver: yupResolver(schema) as any,
    defaultValues: {
      buttonText: defaultValues?.buttonText ?? "",
      anchorId: defaultValues?.anchorId ?? "",
    },
  });

  const handleFormSubmit = (data: FormValues) => {
    const formattedData: CourseStickyBarFormValues = {
      buttonText: data.buttonText || undefined,
      anchorId: data.anchorId || undefined,
    };
    onSubmit(formattedData);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleFormSubmit)} className="grid gap-4">
        <PaziaInput name="buttonText" label="Tekst przycisku (opcjonalnie)" placeholder="np. Zapisz się" />
        <PaziaInput name="anchorId" label="ID kotwicy (opcjonalnie)" placeholder="np. enrollment" />

        <div className="flex justify-end gap-2 border-t border-slate-200 pt-4 dark:border-slate-600">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg border border-slate-300 px-4 py-2 text-slate-700 transition-colors hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
          >
            Anuluj
          </button>
          <PaziaFormButton disabled={isLoading} />
        </div>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    buttonText: yup.string().optional(),
    anchorId: yup.string().optional(),
  })
  .required();

interface FormValues {
  buttonText?: string;
  anchorId?: string;
}

export interface CourseStickyBarFormValues {
  buttonText?: string;
  anchorId?: string;
}
